<template>
  <div class="form-checkbox-buttons">
    <BFormRadioGroup
      :checked="value"
      buttons
      button-variant="checkbox"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import {BFormRadioGroup} from 'bootstrap-vue/src/components/form-radio/form-radio-group'

export default {
  components: {
    BFormRadioGroup,
  },
  inheritAttrs: false,

  props: {
    /**
     * The current value of the checked radio in the group
     */
    value: {
      type: [String, Object, Boolean, Array],
      required: true,
    },
  },
}
</script>

<style lang="scss">


.form-checkbox-buttons {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;

  .btn-checkbox {
    color: $gray-800;
    border-color: $gray-200;

    &.focus,
    &:focus,
    &.active {
      color: $cyan-700;
      border-color: $cyan-700;
      background-color: #fff;
    }

    &:hover:not(.disabled) {
      color: $cyan-700;
      border-color: $gray-200;
      background-color: $cyan-100;
    }

    &.focus,
    &:focus {
      outline: none !important;
      box-shadow: none !important;
    }

    &:disabled,
    &.disabled {
      border-color: $gray-200;
    }
  }
}
</style>
